import React from "react"

function IconListItemUnread({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="list-item-unread"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-list-item-unread"
      {...props}
    >
      <path
        d="M15.947 17.333a.655.655 0 0 1 .106 1.3l-.106.009H4.396a.655.655 0 0 1-.106-1.3l.106-.01h11.55zm0-4.043a.655.655 0 0 1 .106 1.3l-.106.009H4.396a.655.655 0 0 1-.106-1.3l.106-.01h11.55zm4.62-5.756a2.31 2.31 0 1 1-2.218 2.957l-.092.007H4.396a.655.655 0 0 1-.106-1.3l.106-.009h13.86l.093.007a2.311 2.311 0 0 1 2.218-1.662zm0 1.309a1.001 1.001 0 1 0 0 2.002 1.001 1.001 0 0 0 0-2.002zm-4.62-3.639a.655.655 0 0 1 .106 1.3l-.106.01H4.396a.655.655 0 0 1-.106-1.301l.106-.009h11.55z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconListItemUnread
